export const liveCasinoProvider = [
  { id: "All", name: "All" },
  { id: "Aura", name: "Aura Gaming" },
  { id: "JIL", name: "JILI" },
  { id: "EVO", name: "Evolution" },
  { id: "EZU", name: "EZUGI" },
  { id: "BTV", name: "BETGAMES.TV" },
  { name: "Spribe", id: "SPB" },
  { name: "Smart", id: "SMS" },
  { name: "Vivo Gaming", id: "VGL" },
  { name: "Scratch", id: "WAZ" },
  { name: "Mines", id: "TRB" },
  { name: "Tembo", id: "TRB" },
  { id: "TRB", name: "Turbo Games" },
  { id: "NE", name: "NetEnt" },
  { id: "RED", name: "Red Tiger" },
  { id: "1x2", name: "1x2 Gaming" },
  { id: "BPG", name: "Blueprint Gaming" },
  { id: "DS", name: "Dragon Soft" },
  { id: "EVP", name: "Evoplay" },
  { id: "FNG", name: "Fantasma Games" },
  { id: "HAB", name: "Habanero" },
  { id: "HAK", name: "Hacksaw Gaming" },
  { id: "IDS", name: "Iron Dog Studio" },
  { id: "KGL", name: "Kalamba Games" },
  { id: "NLC", name: "Nolimit City" },
  { id: "OMI", name: "OMI Gaming" },
  { id: "OT", name: "OneTouch" },
  { id: "PNG", name: "Play'n GO" },
  { id: "PUG", name: "Push Gaming" },
  { id: "QS", name: "Quickspin" },
  { id: "RLX", name: "Relax Gaming" },
  { id: "RTG", name: "RTG Slots" },
  { id: "SHS", name: "Spearhead Studios" },
  { id: "SM", name: "Slotmill" },
  { id: "TK", name: "Thunderkick" },
  { id: "WOO", name: "Woohoo Games" },
  { id: "YGG", name: "Yggdrasil" },
  { id: "WAZ", name: "Wazdan" },
  { id: "END", name: "Endorphina" },
  { id: "GA", name: "GameArt" },
  { id: "BNG", name: "BNG" },
  { id: "RG", name: "Revolver Gaming" },
  { id: "PRG", name: "Prospect Gaming" },
  { id: "GZX", name: "Gamzix" },
  { id: "CQC", name: "CQ9 Casino" },
  { id: "GMC", name: "Gaming Corps" },
  { id: "TPG", name: "Triple PG" },
  { id: "NGE", name: "NetGame" },
  { id: "SWC", name: "Skywind Casino" },
  { id: "AUX", name: "AvatarUX" },
  { id: "MNP", name: "Manna Play" },
  { id: "FUG", name: "Fugaso" },
  { id: "MOB", name: "Mobilots" },
  { id: "NAG", name: "Naga Games" },
  { id: "OPY", name: "Onlyplay" },
  { id: "BTG", name: "Big Time Gaming" },
  { id: "SLO", name: "Slotopia" },
  { id: "PRS", name: "Print Studios" },
  { id: "CRED", name: "Creedroomz" },
];

export const customAura = [
  {
    game_id: "740001",
    game_name: "Teenpatti T20",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_t20.webp",
    game_code: "ag_teenpatti_t20",
    created_at: 1776167820,
    disabled_at: 0,
  },
  {
    game_id: "740002",
    game_name: "Teenpatti 1 Day",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_1_day.webp",
    game_code: "ag_teenpatti_1_day",
    created_at: 1776167822,
    disabled_at: 0,
  },
  {
    game_id: "740003",
    game_name: "Dragon Tiger",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/dragon_tiger.webp",
    game_code: "ag_dragon_tiger",
    created_at: 1776167823,
    disabled_at: 0,
  },
  {
    game_id: "740004",
    game_name: "7 Up Down",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/7_up_down.webp",
    game_code: "ag_7_up_down",
    created_at: 1776167823,
    disabled_at: 0,
  },
  {
    game_id: "740005",
    game_name: "Hi Low",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/hi_low.webp",
    game_code: "ag_hi_low",
    created_at: 1776167823,
    disabled_at: 0,
  },
  {
    game_id: "740006",
    game_name: "Amar Akbar Anthony",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/amar_akbar_anthony.webp",
    game_code: "ag_amar_akbar_anthony",
    created_at: 1776167823,
    disabled_at: 0,
  },
  {
    game_id: "740007",
    game_name: "Andar Bahar",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/andar_bahar.webp",
    game_code: "ag_andar_bahar",
    created_at: 1776167823,
    disabled_at: 0,
  },
  {
    game_id: "740008",
    game_name: "2 Card Teenpatti",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/2_card_teenpatti.webp",
    game_code: "ag_2_card_teenpatti",
    created_at: 1776167824,
    disabled_at: 0,
  },
  {
    game_id: "740009",
    game_name: "Muflis Teenpatti",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/muflis_teenpatti.webp",
    game_code: "ag_muflis_teenpatti",
    created_at: 1776167824,
    disabled_at: 0,
  },
  {
    game_id: "740010",
    game_name: "Teenpatti Test",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_test.webp",
    game_code: "ag_teenpatti_test",
    created_at: 1776167824,
    disabled_at: 0,
  },
  {
    game_id: "740011",
    game_name: "Teenpatti Open",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_open.webp",
    game_code: "ag_teenpatti_open",
    created_at: 1776167824,
    disabled_at: 0,
  },
  {
    game_id: "740012",
    game_name: "Roulette",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/roulette.webp",
    game_code: "ag_roulette",
    created_at: 1776167825,
    disabled_at: 0,
  },
  {
    game_id: "740013",
    game_name: "29 Card Baccarat",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/29_card_baccarat.webp",
    game_code: "ag_29_card_baccarat",
    created_at: 1776167825,
    disabled_at: 0,
  },
  {
    game_id: "740014",
    game_name: "Baccarat",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/baccarat.webp",
    game_code: "ag_baccarat",
    created_at: 1776167825,
    disabled_at: 0,
  },
  {
    game_id: "740015",
    game_name: "Poker 20-20",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/poker_2020.webp",
    game_code: "ag_poker_2020",
    created_at: 1776167825,
    disabled_at: 0,
  },
  {
    game_id: "740016",
    game_name: "3 Cards Judgement",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/3_cards_judgement.webp",
    game_code: "ag_3_cards_judgement",
    created_at: 1776167825,
    disabled_at: 0,
  },
  {
    game_id: "740017",
    game_name: "Queen Race",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/queen_race.webp",
    game_code: "ag_queen_race",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740018",
    game_name: "Bollywood Casino",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/bollywood_casino.webp",
    game_code: "ag_bollywood_casino",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740019",
    game_name: "Race to 17",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/race_to_17.webp",
    game_code: "ag_race_to_17",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740020",
    game_name: "Trio",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/trio.webp",
    game_code: "ag_trio",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740021",
    game_name: "Sicbo",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/sicbo.webp",
    game_code: "ag_sicbo",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740022",
    game_name: "Matka",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/matka.webp",
    game_code: "ag_matka",
    created_at: 1776167826,
    disabled_at: 0,
  },
  {
    game_id: "740023",
    game_name: "32 cards casino",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/32_cards_casino.webp",
    game_code: "ag_32_cards_casino",
    created_at: 1776167827,
    disabled_at: 0,
  },
  {
    game_id: "740024",
    game_name: "Super Over",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/super_over.webp",
    game_code: "ag_super_over",
    created_at: 1776167827,
    disabled_at: 0,
  },
  {
    game_id: "740025",
    game_name: "Poker",
    category: "Live",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/poker.webp",
    game_code: "ag_poker",
    created_at: 1776167827,
    disabled_at: 0,
  },
  {
    game_id: "740026",
    game_name: "Teenpatti T20 VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_t20_vr.webp",
    game_code: "ag_teenpatti_t20_vr",
    created_at: 1776167827,
    disabled_at: 0,
  },
  {
    game_id: "740027",
    game_name: "Teenpatti 1 Day VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_1_day_vr.webp",
    game_code: "ag_teenpatti_1_day_vr",
    created_at: 1776167827,
    disabled_at: 0,
  },
  {
    game_id: "740028",
    game_name: "7 Up Down VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/7_up_down_vr.webp",
    game_code: "ag_7_up_down_vr",
    created_at: 1776167828,
    disabled_at: 0,
  },
  {
    game_id: "740029",
    game_name: "Dragon Tiger VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/dragon_tiger_vr.webp",
    game_code: "ag_dragon_tiger_vr",
    created_at: 1776167828,
    disabled_at: 0,
  },
  {
    game_id: "740030",
    game_name: "Hi Low VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/hi_low_vr.webp",
    game_code: "ag_hi_low_vr",
    created_at: 1776167828,
    disabled_at: 0,
  },
  {
    game_id: "740031",
    game_name: "Muflis Teenpatti VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/muflis_teenpatti_vr.webp",
    game_code: "ag_muflis_teenpatti_vr",
    created_at: 1776167828,
    disabled_at: 0,
  },
  {
    game_id: "740032",
    game_name: "Amar Akbar Anthony VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/amar_akbar_anthony_vr.webp",
    game_code: "ag_amar_akbar_anthony_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740033",
    game_name: "Andar Bahar VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/andar_bahar_vr.webp",
    game_code: "ag_andar_bahar_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740034",
    game_name: "Poker VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/poker_vr.webp",
    game_code: "ag_poker_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740035",
    game_name: "Matka VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/matka_vr.webp",
    game_code: "ag_matka_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740036",
    game_name: "32 Card Casino VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/32_card_casino_vr.webp",
    game_code: "ag_32_card_casino_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740037",
    game_name: "Bollywood Casino VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/bollywood_casino_vr.webp",
    game_code: "ag_bollywood_casino_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740038",
    game_name: "Casino War VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/casino_war_vr.webp",
    game_code: "ag_casino_war_vr",
    created_at: 1776167829,
    disabled_at: 0,
  },
  {
    game_id: "740039",
    game_name: "Race 20-20 VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/race_2020_vr.webp",
    game_code: "ag_race_2020_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740040",
    game_name: "Baccarat VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/baccarat_vr.webp",
    game_code: "ag_baccarat_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740041",
    game_name: "Trio VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/trio_vr.webp",
    game_code: "ag_trio_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740042",
    game_name: "Queen Race VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/queen_race_vr.webp",
    game_code: "ag_queen_race_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740043",
    game_name: "Teenpatti Test VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_test_vr.webp",
    game_code: "ag_teenpatti_test_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740044",
    game_name: "Teenpatti Open VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_open_vr.webp",
    game_code: "ag_teenpatti_open_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740045",
    game_name: "Poker 20-20 VR",
    category: "Virtual",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/poker_2020_vr.webp",
    game_code: "ag_poker_2020_vr",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740046",
    game_name: "Blastoff",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/blastoff.webp",
    game_code: "ag_blastoff",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740047",
    game_name: "Aviator",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/aviator.webp",
    game_code: "ag_aviator",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740048",
    game_name: "Spin Wheel",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/spin_wheel.webp",
    game_code: "ag_spin_wheel",
    created_at: 1776167830,
    disabled_at: 0,
  },
  {
    game_id: "740049",
    game_name: "Coin Toss",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/coin_toss.webp",
    game_code: "ag_coin_toss",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740050",
    game_name: "Limbo",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/limbo.webp",
    game_code: "ag_limbo",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740051",
    game_name: "Slot Game",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/slot_game.webp",
    game_code: "ag_slot_game",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740052",
    game_name: "Rock Paper Scissors",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/rock_paper_scissors.webp",
    game_code: "ag_rock_paper_scissors",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740053",
    game_name: "Double",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/double.webp",
    game_code: "ag_double",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740054",
    game_name: "Cricket",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/cricket.webp",
    game_code: "ag_cricket",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740055",
    game_name: "Classic Dice",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/classic_dice.webp",
    game_code: "ag_classic_dice",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740056",
    game_name: "Crash",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/crash.webp",
    game_code: "ag_crash",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740057",
    game_name: "Mines",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/mines.webp",
    game_code: "ag_mines",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740058",
    game_name: "Tower Legends",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/tower_legends.webp",
    game_code: "ag_tower_legends",
    created_at: 1776167831,
    disabled_at: 0,
  },
  {
    game_id: "740059",
    game_name: "Sugar Ride",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/sugar_ride.webp",
    game_code: "ag_sugar_ride",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740060",
    game_name: "Button Burst",
    category: "Crash Games",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/button_burst.webp",
    game_code: "ag_button_burst",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740061",
    game_name: "Teenpatti T20 Fast",
    category: "Others",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/teenpatti_t20_fast.webp",
    game_code: "ag_teenpatti_t20_fast",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740062",
    game_name: "7 Up Down Fast",
    category: "Others",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/7_up_down_fast.webp",
    game_code: "ag_7_up_down_fast",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740063",
    game_name: "2 card Teenpatti Fast",
    category: "Others",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/2_card_teenpatti_fast.webp",
    game_code: "ag_2_card_teenpatti_fast",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740064",
    game_name: "Dragon Tiger Fast",
    category: "Others",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/dragon_tiger_fast.webp",
    game_code: "ag_dragon_tiger_fast",
    created_at: 1776167832,
    disabled_at: 0,
  },
  {
    game_id: "740065",
    game_name: "Ball by Ball",
    category: "Others",
    provider_name: "AURA",
    sub_provider_name: "Aura Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/ag/ball_by_ball.webp",
    game_code: "ag_ball_by_ball",
    created_at: 1779103934,
    disabled_at: 0,
  },
];

export const customGamesData = {
  ALL: [
    {
      id: "JIL-goldenempire",
      name: "Golden Empire",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/SLOT/6REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenempire_en_US&type=logo-round&version=1734876747006",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenempire_en_US&type=banner&version=1734876747462",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenempire_en_US&type=logo-square&version=1734876747097",
        },
      ],
    },
    {
      id: "TRB-aero",
      name: "Aero",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-round&version=1701153611106",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=banner&version=1701153611122",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-square&version=1701153611058",
        },
      ],
    },
    {
      id: "TRB-chickenroute",
      name: "Chicken Route",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=logo-round&version=1759744320181",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=banner&version=1759744320113",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=logo-square&version=1759744320180",
        },
      ],
    },

    {
      id: "UPG-aero",
      name: "Aero",
      provider: {
        id: "UPG",
        name: "Upgames",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=logo-round&version=1736421559702",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=banner&version=1736421559950",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=logo-square&version=1736421560403",
        },
      ],
    },
    {
      id: "AVX-aviatrix",
      name: "Aviatrix",
      provider: {
        id: "AVX",
        name: "Aviatrix",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=AVX-aviatrix_en_US&type=logo-round&version=1707799186444",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=AVX-aviatrix_en_US&type=banner&version=1707799184563",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=AVX-aviatrix_en_US&type=logo-square&version=1707799184622",
        },
      ],
    },
    {
      id: "EVP-aviarush",
      name: "Avia Rush",
      provider: {
        id: "EVP",
        name: "Evoplay",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=logo-round&version=1743513151784",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=banner&version=1743513151734",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=logo-square&version=1743513153469",
        },
      ],
    },
    {
      id: "EVP-christmascrash",
      name: "Christmas Crash",
      provider: {
        id: "EVP",
        name: "Evoplay",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=EVP-christmascrash_en_US&type=logo-round&version=1703077357306",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=EVP-christmascrash_en_US&type=banner&version=1703077358200",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=EVP-christmascrash_en_US&type=logo-square&version=1703077358887",
        },
      ],
    },
    {
      id: "KGL-balloonodysseycrash",
      name: "Balloon Odyssey Crash",
      provider: {
        id: "KGL",
        name: "Kalamba",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=KGL-balloonodysseycrash_en_US&type=logo-round&version=1742197936392",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=KGL-balloonodysseycrash_en_US&type=banner&version=1742197936524",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=KGL-balloonodysseycrash_en_US&type=logo-square&version=1742197937166",
        },
      ],
    },
    {
      id: "BTG-millionairetapcards",
      name: "Millionaire Tapcards",
      provider: {
        id: "BTG",
        name: "Big Time Gaming",
      },
      category: "CASINO/LOTTERY/SCRATCH_CARD",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=BTG-millionairetapcards_en_US&type=logo-round&version=1751357128658",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=BTG-millionairetapcards_en_US&type=banner&version=1751357128820",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=BTG-millionairetapcards_en_US&type=logo-square&version=1751357128598",
        },
      ],
    },
    {
      id: "BPG-blazingcash",
      name: "Blazing Cash",
      provider: {
        id: "BPG",
        name: "Blueprint",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=BPG-blazingcash_en_US&type=logo-round&version=1743671604307",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=BPG-blazingcash_en_US&type=banner&version=1743671603991",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=BPG-blazingcash_en_US&type=logo-square&version=1743671604063",
        },
      ],
    },
    {
      id: "GLX-cashshow",
      name: "Cash Show",
      provider: {
        id: "GLX",
        name: "Galaxsys",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=GLX-cashshow_en_US&type=logo-round&version=1692192292427",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=GLX-cashshow_en_US&type=banner&version=1692192292523",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=GLX-cashshow_en_US&type=logo-square&version=1692192291560",
        },
      ],
    },
    {
      id: "OPY-cosmox",
      name: "CosmoX",
      provider: {
        id: "OPY",
        name: "Onlyplay",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=OPY-cosmox_en_US&type=logo-round&version=1731397184876",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=OPY-cosmox_en_US&type=banner&version=1731397184604",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=OPY-cosmox_en_US&type=logo-square&version=1731397184597",
        },
      ],
    },
    {
      id: "BTL-crash",
      name: "CRASH",
      provider: {
        id: "BTL",
        name: "ICONIC21",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=BTL-crash_en_US&type=logo-round&version=1763031237397",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=BTL-crash_en_US&type=banner&version=1763031243391",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=BTL-crash_en_US&type=logo-square&version=1763031240633",
        },
      ],
    },
    {
      id: "JIL-crashcricket",
      name: "Crash Cricket",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashcricket_en_US&type=logo-round&version=1735484639512",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashcricket_en_US&type=banner&version=1735484621423",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashcricket_en_US&type=logo-square&version=1735484626196",
        },
      ],
    },
    {
      id: "JIL-crashgoal",
      name: "Crash Goal",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashgoal_en_US&type=logo-round&version=1735484387680",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashgoal_en_US&type=banner&version=1735484411662",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashgoal_en_US&type=logo-square&version=1735484402699",
        },
      ],
    },
    {
      id: "JIL-crashtouchdown",
      name: "Crash Touchdown",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashtouchdown_en_US&type=logo-round&version=1741334453989",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashtouchdown_en_US&type=banner&version=1741334454103",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-crashtouchdown_en_US&type=logo-square&version=1741334454642",
        },
      ],
    },
    {
      id: "SMS-jetx3",
      name: "Avia Star",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-round&version=1727150257293",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=banner&version=1727150257428",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-square&version=1727150259330",
        },
      ],
    },
    {
      id: "SMS-baloon",
      name: "Balloon",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=logo-round&version=1722306912031",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=banner&version=1722306911921",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=logo-square&version=1722306913836",
        },
      ],
    },
    {
      id: "SMS-cricketx",
      name: "CricketX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=logo-round&version=1722258306825",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=banner&version=1722258306809",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=logo-square&version=1722258307627",
        },
      ],
    },
    {
      id: "SMS-doublex",
      name: "DoubleX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=logo-round&version=1722258909025",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=banner&version=1722258909339",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=logo-square&version=1722258909650",
        },
      ],
    },
    {
      id: "SMS-footballx",
      name: "FootballX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=logo-round&version=1722259249620",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=banner&version=1722259249770",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=logo-square&version=1722259249932",
        },
      ],
    },
    {
      id: "SMS-jetx",
      name: "JetX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-round&version=1759997798214",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=banner&version=1759997796539",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-square&version=1759997798075",
        },
      ],
    },
    {
      id: "SMS-plinkox",
      name: "PlinkoX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/PLINKO",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=logo-round&version=1722261549466",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=banner&version=1722261549359",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=logo-square&version=1722261549943",
        },
      ],
    },
  ],
  aviator: [
    {
      id: "SPB-aviator",
      name: "Aviator",
      provider: {
        id: "SPB",
        name: "Spribe",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=logo-round&version=1717639255260",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=banner&version=1717639255542",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=logo-square&version=1717639255289",
        },
      ],
    },
    {
      id: "SMS-jetx3",
      name: "Avia Star",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-round&version=1727150257293",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=banner&version=1727150257428",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-square&version=1727150259330",
        },
      ],
    },
    {
      id: "SMS-jetx",
      name: "JetX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-round&version=1759997798214",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=banner&version=1759997796539",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-square&version=1759997798075",
        },
      ],
    },
    {
      id: "GZX-pilot",
      name: "Pilot",
      provider: {
        id: "GZX",
        name: "Gamzix",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=GZX-pilot_en_US&type=logo-round&version=1664353637659",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=GZX-pilot_en_US&type=banner&version=1664353635933",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=GZX-pilot_en_US&type=logo-square&version=1664353635245",
        },
      ],
    },
    {
      id: "RED-astronaut",
      name: "Astronaut",
      provider: {
        id: "RED",
        name: "Red Tiger",
      },
      category: "CASINO/SLOT/1REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=RED-astronaut_en_US&type=logo-round&version=1686814983887",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=RED-astronaut_en_US&type=banner&version=1686814991616",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=RED-astronaut_en_US&type=logo-square&version=1686814991235",
        },
      ],
    },
    {
      id: "TRB-aero",
      name: "Aero",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-round&version=1701153611106",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=banner&version=1701153611122",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-square&version=1701153611058",
        },
      ],
    },
    {
      id: "UPG-aero",
      name: "Aero",
      provider: {
        id: "UPG",
        name: "Upgames",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=logo-round&version=1736421559702",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=banner&version=1736421559950",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=UPG-aero_en_US&type=logo-square&version=1736421560403",
        },
      ],
    },
    {
      id: "BTL-lightspeed",
      name: "Lightspeed",
      provider: {
        id: "BTL",
        name: "ICONIC21",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=BTL-lightspeed_en_US&type=logo-round&version=1743688928306",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=BTL-lightspeed_en_US&type=banner&version=1743688928288",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=BTL-lightspeed_en_US&type=logo-square&version=1743688928366",
        },
      ],
    },
    {
      id: "EVP-aviarush",
      name: "Avia Rush",
      provider: {
        id: "EVP",
        name: "Evoplay",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=logo-round&version=1743513151784",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=banner&version=1743513151734",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=EVP-aviarush_en_US&type=logo-square&version=1743513153469",
        },
      ],
    },
  ],
  colorPridict: [
    {
      id: "EVO-supercolorgame",
      name: "Super Color Game",
      provider: {
        id: "EVO",
        name: "Evolution",
      },
      category: "CASINO/GAME_SHOW",
      demoSupport: false,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=EVO-supercolorgame_en_US&type=logo-round&version=1746442361040",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=EVO-supercolorgame_en_US&type=banner&version=1746442360937",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=EVO-supercolorgame_en_US&type=logo-square&version=1746442361033",
        },
      ],
    },
    {
      id: "JIL-colorprediction",
      name: "Color Prediction",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/INSTANTWIN/COLOR_GAMES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-colorprediction_en_US&type=logo-round&version=1735313808981",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-colorprediction_en_US&type=banner&version=1735313809101",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-colorprediction_en_US&type=logo-square&version=1735313809303",
        },
      ],
    },
    {
      id: "TRB-1tapmines",
      name: "1Tap Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=logo-round&version=1707216583074",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=banner&version=1707216583187",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=logo-square&version=1707216583906",
        },
      ],
    },
    {
      id: "TRB-aero",
      name: "Aero",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-round&version=1701153611106",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=banner&version=1701153611122",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-aero_en_US&type=logo-square&version=1701153611058",
        },
      ],
    },
    {
      id: "TRB-ballball",
      name: "Ball & Ball",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/OTHER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-ballball_en_US&type=logo-round&version=1689797789169",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-ballball_en_US&type=banner&version=1689797785480",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-ballball_en_US&type=logo-square&version=1689797783600",
        },
      ],
    },
    {
      id: "TRB-balloondoggo",
      name: "Balloon Doggo",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/OTHER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-balloondoggo_en_US&type=logo-round&version=1762850644134",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-balloondoggo_en_US&type=banner&version=1762850644145",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-balloondoggo_en_US&type=logo-square&version=1762850644249",
        },
      ],
    },
    {
      id: "TRB-bayraktar",
      name: "Bayraktar",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-bayraktar_en_US&type=logo-round&version=1689799212864",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-bayraktar_en_US&type=banner&version=1689799220481",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-bayraktar_en_US&type=logo-square&version=1689799209819",
        },
      ],
    },
    {
      id: "TRB-bookofmines",
      name: "Book of Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=logo-round&version=1712822158908",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=banner&version=1712822182370",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=logo-square&version=1712822158729",
        },
      ],
    },
    {
      id: "TRB-bubbles",
      name: "Bubbles",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-bubbles_en_US&type=logo-round&version=1691476807740",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-bubbles_en_US&type=banner&version=1691476807624",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-bubbles_en_US&type=logo-square&version=1691476808513",
        },
      ],
    },
    {
      id: "TRB-catanza",
      name: "Catanza",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-catanza_en_US&type=logo-round&version=1740994822674",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-catanza_en_US&type=banner&version=1740994837691",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-catanza_en_US&type=logo-square&version=1740994833285",
        },
      ],
    },
    {
      id: "TRB-chickenroute",
      name: "Chicken Route",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=logo-round&version=1759744320181",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=banner&version=1759744320113",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-chickenroute_en_US&type=logo-square&version=1759744320180",
        },
      ],
    },
    {
      id: "TRB-crashx",
      name: "Crash X",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashx_en_US&type=logo-round&version=1689793148628",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashx_en_US&type=banner&version=1689793159588",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashx_en_US&type=logo-square&version=1689793154196",
        },
      ],
    },
    {
      id: "TRB-crashxfootballedition",
      name: "Crash X Football Edition",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashxfootballedition_en_US&type=logo-round&version=1721807600499",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashxfootballedition_en_US&type=banner&version=1721807600645",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-crashxfootballedition_en_US&type=logo-square&version=1721807600648",
        },
      ],
    },
    {
      id: "TRB-cricketboom",
      name: "Cricket Boom",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-cricketboom_en_US&type=logo-round&version=1743498685695",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-cricketboom_en_US&type=banner&version=1743498685579",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-cricketboom_en_US&type=logo-square&version=1743498686325",
        },
      ],
    },
    {
      id: "TRB-crystalpoker",
      name: "Crystal Poker",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/COLOR_GAMES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-crystalpoker_en_US&type=logo-round&version=1722480753193",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-crystalpoker_en_US&type=banner&version=1722480753764",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-crystalpoker_en_US&type=logo-square&version=1722480753757",
        },
      ],
    },
    {
      id: "TRB-dicethrice",
      name: "Dice Thrice",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicethrice_en_US&type=logo-round&version=1727165673319",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicethrice_en_US&type=banner&version=1727165673305",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicethrice_en_US&type=logo-square&version=1727165673502",
        },
      ],
    },
    {
      id: "TRB-dicetwice",
      name: "Dice Twice",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicetwice_en_US&type=logo-round&version=1689799062599",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicetwice_en_US&type=banner&version=1689799060653",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-dicetwice_en_US&type=logo-square&version=1689799065045",
        },
      ],
    },
    {
      id: "TRB-dogsstreet",
      name: "Dogs' Street",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-dogsstreet_en_US&type=logo-round&version=1689793785514",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-dogsstreet_en_US&type=banner&version=1689793783867",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-dogsstreet_en_US&type=logo-square&version=1689793783053",
        },
      ],
    },
    {
      id: "TRB-donnyking",
      name: "Donny King",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-donnyking_en_US&type=logo-round&version=1724236987954",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-donnyking_en_US&type=banner&version=1724236986724",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-donnyking_en_US&type=logo-square&version=1724236988583",
        },
      ],
    },
    {
      id: "TRB-doubleroll",
      name: "Double Roll",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/COLOR_GAMES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-doubleroll_en_US&type=logo-round&version=1689793490265",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-doubleroll_en_US&type=banner&version=1689793492149",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-doubleroll_en_US&type=logo-square&version=1689793491973",
        },
      ],
    },
    {
      id: "TRB-fastfielder",
      name: "Fast Fielder",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-fastfielder_en_US&type=logo-round&version=1691481182095",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-fastfielder_en_US&type=banner&version=1691481182901",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-fastfielder_en_US&type=logo-square&version=1691481182991",
        },
      ],
    },
    {
      id: "TRB-fruittowers",
      name: "Fruit Towers",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-fruittowers_en_US&type=logo-round&version=1689793649074",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-fruittowers_en_US&type=banner&version=1689793644086",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-fruittowers_en_US&type=logo-square&version=1689793646873",
        },
      ],
    },
    {
      id: "TRB-hamsta",
      name: "Hamsta",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-hamsta_en_US&type=logo-round&version=1690284303204",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-hamsta_en_US&type=banner&version=1689798614661",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-hamsta_en_US&type=logo-square&version=1689798610256",
        },
      ],
    },
    {
      id: "TRB-hilo",
      name: "Hi-Lo",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-hilo_en_US&type=logo-round&version=1691477791930",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-hilo_en_US&type=banner&version=1691477791622",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-hilo_en_US&type=logo-square&version=1691477792466",
        },
      ],
    },
    {
      id: "TRB-javelinx",
      name: "JavelinX",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/TABLEGAME/WHEEL_OF_FORTUNE",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-javelinx_en_US&type=logo-round&version=1689798739818",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-javelinx_en_US&type=banner&version=1689798739704",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-javelinx_en_US&type=logo-square&version=1689798736547",
        },
      ],
    },
    {
      id: "TRB-jewelclicker",
      name: "Jewel Clicker",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/OTHER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-jewelclicker_en_US&type=logo-round&version=1730136226340",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-jewelclicker_en_US&type=banner&version=1730136232406",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-jewelclicker_en_US&type=logo-square&version=1730136227991",
        },
      ],
    },
    {
      id: "TRB-limborider",
      name: "Limbo Rider",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-limborider_en_US&type=logo-round&version=1689797890533",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-limborider_en_US&type=banner&version=1689797946799",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-limborider_en_US&type=logo-square&version=1689797888668",
        },
      ],
    },
    {
      id: "TRB-magickeno",
      name: "Magic Keno",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/LOTTERY/KENO",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-magickeno_en_US&type=logo-round&version=1689797500916",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-magickeno_en_US&type=banner&version=1689797499971",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-magickeno_en_US&type=logo-square&version=1689797498854",
        },
      ],
    },
    {
      id: "TRB-mines",
      name: "Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=logo-round&version=1689799361155",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=banner&version=1689799364971",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=logo-square&version=1689799362324",
        },
      ],
    },
    {
      id: "TRB-multiplayermines",
      name: "Multiplayer Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=logo-round&version=1717673245492",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=banner&version=1717673245708",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=logo-square&version=1717673246863",
        },
      ],
    },
    {
      id: "TRB-mysteco",
      name: "Mysteco",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/TABLEGAME/WHEEL_OF_FORTUNE",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-mysteco_en_US&type=logo-round&version=1754890679192",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-mysteco_en_US&type=banner&version=1754890679232",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-mysteco_en_US&type=logo-square&version=1754890679925",
        },
      ],
    },
    {
      id: "TRB-neko",
      name: "Neko",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/TABLEGAME/WHEEL_OF_FORTUNE",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-neko_en_US&type=logo-round&version=1689793957921",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-neko_en_US&type=banner&version=1689793957370",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-neko_en_US&type=logo-square&version=1689793958354",
        },
      ],
    },
    {
      id: "TRB-pandabao",
      name: "Panda Bao",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-pandabao_en_US&type=logo-round&version=1751355197623",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-pandabao_en_US&type=banner&version=1751355198783",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-pandabao_en_US&type=logo-square&version=1751355197664",
        },
      ],
    },
    {
      id: "TRB-pumpedx",
      name: "PumpedX",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-pumpedx_en_US&type=logo-round&version=1727165854579",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-pumpedx_en_US&type=banner&version=1727165854612",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-pumpedx_en_US&type=logo-square&version=1727165855073",
        },
      ],
    },
    {
      id: "TRB-ringsofolympus",
      name: "Rings of Olympus",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/SLOT/1REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-ringsofolympus_en_US&type=logo-round&version=1746442502156",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-ringsofolympus_en_US&type=banner&version=1746442502914",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-ringsofolympus_en_US&type=logo-square&version=1746442503419",
        },
      ],
    },
    {
      id: "TRB-savetheprincess",
      name: "Save the Princess",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-savetheprincess_en_US&type=logo-round&version=1689794246104",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-savetheprincess_en_US&type=banner&version=1689794247993",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-savetheprincess_en_US&type=logo-square&version=1689794245953",
        },
      ],
    },
    {
      id: "TRB-spinstrike",
      name: "Spin Strike",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/TABLEGAME/WHEEL_OF_FORTUNE",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-spinstrike_en_US&type=logo-round&version=1691480701111",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-spinstrike_en_US&type=banner&version=1691480700744",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-spinstrike_en_US&type=logo-square&version=1691480701100",
        },
      ],
    },
    {
      id: "TRB-stairs",
      name: "Stairs",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-stairs_en_US&type=logo-round&version=1689798454569",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-stairs_en_US&type=banner&version=1689798453335",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-stairs_en_US&type=logo-square&version=1689798454195",
        },
      ],
    },
    {
      id: "TRB-tapinata",
      name: "TAPinata",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/GATCHA",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-tapinata_en_US&type=logo-round&version=1756705805619",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-tapinata_en_US&type=banner&version=1756705805586",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-tapinata_en_US&type=logo-square&version=1756705805627",
        },
      ],
    },
    {
      id: "TRB-towers",
      name: "Towers",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-towers_en_US&type=logo-round&version=1689793320519",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-towers_en_US&type=banner&version=1689793323010",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-towers_en_US&type=logo-square&version=1689793315932",
        },
      ],
    },
    {
      id: "TRB-tradingdice",
      name: "Trading Dice",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-tradingdice_en_US&type=logo-round&version=1703643647993",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-tradingdice_en_US&type=banner&version=1703643647743",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-tradingdice_en_US&type=logo-square&version=1703643650025",
        },
      ],
    },
    {
      id: "TRB-turbomines",
      name: "Turbo Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=logo-round&version=1689794116071",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=banner&version=1689794126050",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=logo-square&version=1689794112215",
        },
      ],
    },
    {
      id: "TRB-turboplinko",
      name: "Turbo Plinko",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/PLINKO",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-turboplinko_en_US&type=logo-round&version=1689797645530",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-turboplinko_en_US&type=banner&version=1689797643356",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-turboplinko_en_US&type=logo-square&version=1689797640159",
        },
      ],
    },
    {
      id: "TRB-vortex",
      name: "Vortex",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/SLOT/1REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortex_en_US&type=logo-round&version=1745219966304",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortex_en_US&type=banner&version=1745219966193",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortex_en_US&type=logo-square&version=1745219966356",
        },
      ],
    },
    {
      id: "TRB-vortexhalloween",
      name: "Vortex Halloween",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/SLOT/1REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortexhalloween_en_US&type=logo-round&version=1760962223471",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortexhalloween_en_US&type=banner&version=1760962224207",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-vortexhalloween_en_US&type=logo-square&version=1760962224953",
        },
      ],
    },
    {
      id: "TRB-wicketblast",
      name: "Wicket Blast",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-wicketblast_en_US&type=logo-round&version=1691480899213",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-wicketblast_en_US&type=banner&version=1691480898962",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-wicketblast_en_US&type=logo-square&version=1691480899298",
        },
      ],
    },
    {
      id: "SMS-jetx3",
      name: "Avia Star",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-round&version=1727150257293",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=banner&version=1727150257428",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx3_en_US&type=logo-square&version=1727150259330",
        },
      ],
    },
    {
      id: "SMS-baloon",
      name: "Balloon",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=logo-round&version=1722306912031",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=banner&version=1722306911921",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-baloon_en_US&type=logo-square&version=1722306913836",
        },
      ],
    },
    {
      id: "SMS-cheesyroad",
      name: "Cheesy Road",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-cheesyroad_en_US&type=logo-round&version=1765171793509",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-cheesyroad_en_US&type=banner&version=1765171793598",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-cheesyroad_en_US&type=logo-square&version=1765171793560",
        },
      ],
    },
    {
      id: "SMS-chickenhighway",
      name: "Chicken Highway",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-chickenhighway_en_US&type=logo-round&version=1764918735528",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-chickenhighway_en_US&type=banner&version=1764918731712",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-chickenhighway_en_US&type=logo-square&version=1764918745109",
        },
      ],
    },
    {
      id: "SMS-cricketx",
      name: "CricketX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=logo-round&version=1722258306825",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=banner&version=1722258306809",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-cricketx_en_US&type=logo-square&version=1722258307627",
        },
      ],
    },
    {
      id: "SMS-doublex",
      name: "DoubleX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=logo-round&version=1722258909025",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=banner&version=1722258909339",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-doublex_en_US&type=logo-square&version=1722258909650",
        },
      ],
    },
    {
      id: "SMS-footballx",
      name: "FootballX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=logo-round&version=1722259249620",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=banner&version=1722259249770",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-footballx_en_US&type=logo-square&version=1722259249932",
        },
      ],
    },
    {
      id: "SMS-jetx",
      name: "JetX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/CRASH",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-round&version=1759997798214",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=banner&version=1759997796539",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jetx_en_US&type=logo-square&version=1759997798075",
        },
      ],
    },
    {
      id: "SMS-jinglebellbonanza",
      name: "Jingle Bell Bonanza",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-jinglebellbonanza_en_US&type=logo-round&version=1762849609388",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-jinglebellbonanza_en_US&type=banner&version=1762849609060",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-jinglebellbonanza_en_US&type=logo-square&version=1762849611679",
        },
      ],
    },
    {
      id: "SMS-multihot5deluxe",
      name: "Multi Hot 5 Deluxe",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/SLOT/3REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5deluxe_en_US&type=logo-round&version=1763976636389",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5deluxe_en_US&type=banner&version=1763976633208",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5deluxe_en_US&type=logo-square&version=1763976631787",
        },
      ],
    },
    {
      id: "SMS-multihot5superwilds",
      name: "Multi Hot 5 Super Wilds",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5superwilds_en_US&type=logo-round&version=1763976307914",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5superwilds_en_US&type=banner&version=1763976307988",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-multihot5superwilds_en_US&type=logo-square&version=1763976308069",
        },
      ],
    },
    {
      id: "SMS-plinkox",
      name: "PlinkoX",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/INSTANTWIN/PLINKO",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=logo-round&version=1722261549466",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=banner&version=1722261549359",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-plinkox_en_US&type=logo-square&version=1722261549943",
        },
      ],
    },
    {
      id: "SMS-wheelofdestiny",
      name: "Wheel of Destiny",
      provider: {
        id: "SMS",
        name: "Smartsoft",
      },
      category: "CASINO/TABLEGAME/WHEEL_OF_FORTUNE",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SMS-wheelofdestiny_en_US&type=logo-round&version=1762849719080",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SMS-wheelofdestiny_en_US&type=banner&version=1762849718727",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SMS-wheelofdestiny_en_US&type=logo-square&version=1762849719592",
        },
      ],
    },
  ],

  Mines: [
    {
      id: "HAK-mines",
      name: "Mines",
      provider: {
        id: "HAK",
        name: "Hacksaw",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=HAK-mines_en_US&type=logo-round&version=1727765918685",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=HAK-mines_en_US&type=banner&version=1727765918322",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=HAK-mines_en_US&type=logo-square&version=1727765918696",
        },
      ],
    },
    {
      id: "SPB-mines",
      name: "Mines",
      provider: {
        id: "SPB",
        name: "Spribe",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=SPB-mines_en_US&type=logo-round&version=1637301832624",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=SPB-mines_en_US&type=banner&version=1637301832150",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=SPB-mines_en_US&type=logo-square&version=1671526029768",
        },
      ],
    },
    {
      id: "TRB-1tapmines",
      name: "1Tap Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=logo-round&version=1707216583074",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=banner&version=1707216583187",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-1tapmines_en_US&type=logo-square&version=1707216583906",
        },
      ],
    },
    {
      id: "TRB-bookofmines",
      name: "Book of Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=logo-round&version=1712822158908",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=banner&version=1712822182370",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-bookofmines_en_US&type=logo-square&version=1712822158729",
        },
      ],
    },
    {
      id: "TRB-mines",
      name: "Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=logo-round&version=1689799361155",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=banner&version=1689799364971",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-mines_en_US&type=logo-square&version=1689799362324",
        },
      ],
    },
    {
      id: "TRB-multiplayermines",
      name: "Multiplayer Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=logo-round&version=1717673245492",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=banner&version=1717673245708",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-multiplayermines_en_US&type=logo-square&version=1717673246863",
        },
      ],
    },
    {
      id: "TRB-turbomines",
      name: "Turbo Mines",
      provider: {
        id: "TRB",
        name: "Turbo Games",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=logo-round&version=1689794116071",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=banner&version=1689794126050",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=TRB-turbomines_en_US&type=logo-square&version=1689794112215",
        },
      ],
    },
    {
      id: "GLX-fmines",
      name: "F Mines",
      provider: {
        id: "GLX",
        name: "Galaxsys",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=GLX-fmines_en_US&type=logo-round&version=1692005766348",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=GLX-fmines_en_US&type=banner&version=1692005765936",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=GLX-fmines_en_US&type=logo-square&version=1692005766333",
        },
      ],
    },
    {
      id: "GLX-turbomines",
      name: "Turbo Mines",
      provider: {
        id: "GLX",
        name: "Galaxsys",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=GLX-turbomines_en_US&type=logo-round&version=1703639624274",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=GLX-turbomines_en_US&type=banner&version=1703639621880",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=GLX-turbomines_en_US&type=logo-square&version=1703639624256",
        },
      ],
    },
    {
      id: "GMC-ragingzeusmines",
      name: "Raging Zeus Mines",
      provider: {
        id: "GMC",
        name: "Gaming Corps",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=GMC-ragingzeusmines_en_US&type=logo-round&version=1696433323994",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=GMC-ragingzeusmines_en_US&type=banner&version=1696433323931",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=GMC-ragingzeusmines_en_US&type=logo-square&version=1696433326372",
        },
      ],
    },
    {
      id: "JIL-minesgold",
      name: "Mines Gold",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-minesgold_en_US&type=logo-round&version=1735483905390",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-minesgold_en_US&type=banner&version=1735483920761",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-minesgold_en_US&type=logo-square&version=1735483901668",
        },
      ],
    },
    {
      id: "PTC-mysticmines",
      name: "Mystic Mines",
      provider: {
        id: "PTC",
        name: "Playtech Casino",
      },
      category: "CASINO/SLOT/6REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=PTC-mysticmines_en_US&type=logo-round&version=1757924017354",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=PTC-mysticmines_en_US&type=banner&version=1757924017346",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=PTC-mysticmines_en_US&type=logo-square&version=1757924018433",
        },
      ],
    },
    {
      id: "UPG-mines",
      name: "Mines",
      provider: {
        id: "UPG",
        name: "Upgames",
      },
      category: "CASINO/INSTANTWIN/MINES",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=UPG-mines_en_US&type=logo-round&version=1740988462583",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=UPG-mines_en_US&type=banner&version=1740988469205",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=UPG-mines_en_US&type=logo-square&version=1740988464447",
        },
      ],
    },
  ],

  funGames: [
    {
      id: "HAK-hilo",
      name: "Hi-Lo",
      provider: {
        id: "HAK",
        name: "Hacksaw",
      },
      category: "CASINO/INSTANTWIN/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=HAK-hilo_en_US&type=logo-round&version=1687854246273",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=HAK-hilo_en_US&type=banner&version=1687854188311",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=HAK-hilo_en_US&type=logo-square&version=1687854185726",
        },
      ],
    },
    {
      id: "OT-andarbahar",
      name: "Andar Bahar",
      provider: {
        id: "OT",
        name: "OneTouch",
      },
      category: "CASINO/TABLEGAME/ANDAR_BAHAR",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=OT-andarbahar_en_US&type=logo-round&version=1719391913734",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=OT-andarbahar_en_US&type=banner&version=1719391913933",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=OT-andarbahar_en_US&type=logo-square&version=1719391913819",
        },
      ],
    },
    {
      id: "OT-baccarat",
      name: "Baccarat",
      provider: {
        id: "OT",
        name: "OneTouch",
      },
      category: "CASINO/TABLEGAME/BACCARAT",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=OT-baccarat_en_US&type=logo-round&version=1564541585241",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=OT-baccarat_en_US&type=banner&version=1564541585133",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=OT-baccarat_en_US&type=logo-square&version=1663746862378",
        },
      ],
    },
    {
      id: "HAK-twentyone",
      name: "Twenty-One",
      provider: {
        id: "HAK",
        name: "Hacksaw",
      },
      category: "CASINO/INSTANTWIN/OTHER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=HAK-twentyone_en_US&type=logo-round&version=1699940744186",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=HAK-twentyone_en_US&type=banner&version=1699940743952",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=HAK-twentyone_en_US&type=logo-square&version=1699940744244",
        },
      ],
    },
    {
      id: "JIL-pokerking",
      name: "Poker King",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/TABLEGAME/POKER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-pokerking_en_US&type=logo-round&version=1735056183175",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-pokerking_en_US&type=banner&version=1735056183313",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-pokerking_en_US&type=logo-square&version=1735056183380",
        },
      ],
    },
    {
      id: "JIL-goldenqueen",
      name: "Golden Queen",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/SLOT/5REEL",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenqueen_en_US&type=logo-round&version=1734620632104",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenqueen_en_US&type=banner&version=1734620632412",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-goldenqueen_en_US&type=logo-square&version=1734620632224",
        },
      ],
    },
    {
      id: "JIL-7up7down",
      name: "7up7down",
      provider: {
        id: "JIL",
        name: "JiLi",
      },
      category: "CASINO/TABLEGAME/HIGHER_LOWER",
      demoSupport: true,
      images: [
        {
          type: "logo-round",
          url: "https://client.qtlauncher.com/images/?id=JIL-7up7down_en_US&type=logo-round&version=1735056385933",
        },
        {
          type: "banner",
          url: "https://client.qtlauncher.com/images/?id=JIL-7up7down_en_US&type=banner&version=1735056385832",
        },
        {
          type: "logo-square",
          url: "https://client.qtlauncher.com/images/?id=JIL-7up7down_en_US&type=logo-square&version=1735056385975",
        },
      ],
    },
  ],
};
